import { render } from "./BarSlotWithValue.vue?vue&type=template&id=5a5c9009&scoped=true"
import script from "./BarSlotWithValue.vue?vue&type=script&lang=js"
export * from "./BarSlotWithValue.vue?vue&type=script&lang=js"

import "./BarSlotWithValue.vue?vue&type=style&index=0&id=5a5c9009&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5c9009"]])

export default __exports__